var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeSwitcherOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand_more_black_24dp (1)",
    clipPath: "url(#clip0_217_733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9327 6.68835L9.49023 10.1234L6.04773 6.68835L4.99023 7.74585L9.49023 12.2459L13.9902 7.74585L12.9327 6.68835Z",
    fill: "#4D5758"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.490234 0.24585)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeSwitcherOpened);
export default __webpack_public_path__ + "static/media/tree-switcher-opened.c2ecd13624a8357b27bdb3ad2eab01ee.svg";
export { ForwardRef as ReactComponent };